<template>
  <div :class="`card ${cardCssClass(game)}`">
    <div class="rank"><Rank :rank="storeRank" /></div>
    <div class="icon"><Icon :src="game.icon" :link="game.storeAppLink"/></div>
    <div class="app-details">
      <!-- todo: use vue-mq to use media queries in js -->
      <Title :title="game.name" :link="game.storeAppLink" class="large-screen"/>
      <Title :title="game.name" class="small-screen"/>
      <Publisher :name="game.companyName" :link="game.storeCompanyLink"/>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Game/Icon';
import Publisher from '@/components/Game/Publisher';
import Rank from '@/components/Game/Rank';
import Title from '@/components/Game/Title';

export default {
  name: 'CardComponent',
  components: {
    Icon,
    Publisher,
    Rank,
    Title,
  },
  props: ['game', 'storeRank'],
  methods: {
    cardCssClass(game) {
      let cssClass = '';

      if (game && game.companyName && game.companyName.toLowerCase() === 'voodoo') {
        cssClass = 'voodoo';
      }

      return cssClass;
    },
  },
};
</script>

<style lang="scss">
  @use '@/assets/common.scss' as *;

  .card {
    display: flex;
    flex-direction: row;
    height: 50px;
    background: #fdfdfd;
    padding: 2px 0;
    border: 1px solid #ebeef5;
    border-width: 0 1px 1px 0;
    font-size: 14px;
    color: #606266;

    @media #{$media-large-screen} {
      width: 440px;
      height: 70px;
      margin-right: 28px;
      margin-bottom: -1px;
      border-width: 1px;
    }

    &.voodoo {
      background: #dfffdd;
    }

    .rank {
      width: 40px;
      min-width: 40px;
      text-align: center;

      @media #{$media-large-screen} {
        width: 56px;
        min-width: 56px;
      }

      > span {
        @media #{$media-large-screen} {
          line-height: 1.6em;
          width: 1.5em;
          font-size: 1.2em;
          border-width: 3px;
        }
      }
    }

    .icon, .rank {
      align-self: center;
    }

    .app-details {
      flex: 1;
      display: flex;
      text-align: left;
      justify-content: center;
      flex-direction: column;
      padding: 0 4px 0 8px;
      line-height: 23px;
      white-space: nowrap;
      overflow: hidden;

      > span {
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .large-screen {
        display: none;
      }

      @media #{$media-large-screen} {
        /*line-height: 30px;*/
        line-height: 1.6em;
        font-size: 1.4em;

        .large-screen {
          display: block;
        }

        .small-screen {
          display: none;
        }
      }
    }
  }
</style>
